<template>
  <div>
    <div class="bkg">
    </div>
    <div>
      <img src="@/assets/icons/ikea_icon.png" class="ikea-icon" />
      <h1 class="ikea-title">宜家IKEA</h1>
      <h2 class="sub-title">开启全新线上体验</h2>
      <div class="qr-code-container">
        <img src="@/assets/icons/android-download-page-qrcode.png" class="qr-code" />
      </div>
    </div>
    <wechat-overlay v-if="system == 'Wechat'" />
  </div>
</template>

<script>
const system = require("@/libs/system");
const APP_SCHEME = process.env.APP_SCHEME || "ikea";
const offlineConfig = require("@/config/appOfflinePromotion.json");
const smsConfig = require("@/config/appSMSPromotion.json");
const interIkeaConfig = require("@/config/appInterIkeaPromotion.json");

import WechatOverlay from "@/components/WechatOverlay";
import mbff from "@/libs/mbff"

export default {
  components: {
    WechatOverlay
  },
  data() {
    return {
      appScheme: APP_SCHEME,
      system: system.currentSystem()
    };
  },
  mounted() {
    if (window.injectProperty && window.injectProperty.prerender) {
      return;
    }
    if (this.system == "Wechat") {
      return;
    }
    const redirectId = this.$route.query.redirect_id;
    const shortLinkId = this.$route.query.shortLinkId;
    if (redirectId) {
      this.navToRedirectId(redirectId)
    } else if (shortLinkId) {
      this.navToshortLinkId(shortLinkId)
    } else {
      // https://res.app.ikea.cn/page/qr.html?url=https://ikeaapp/web?url=https://res.app.ikea.com/...?key=xxx
      // link pattern: https://res.app.ikea.cn/page/qr.html?url=https://ikeaapp/product?id=49279294
      var self = this;
      const url = this.$route.query.url;
      var appLink = `${APP_SCHEME}://`;
      if (url) {
        if (url.startsWith('ikea://') && process.env.APP_SCHEME === 'ikeaqa') {
          appLink = appLink + url.split("ikea://")[1];
        } else if (url.startsWith("https://ikeaapp/")) {
          appLink = appLink + url.split("https://ikeaapp/")[1];
        } else {
          appLink = url;
        }

        var params = []
        for (var key in this.$route.query) {
          if (key !== 'url') {
            params.push(`${key}=${this.$route.query[key]}`)
          }
        }
        if (params.length > 0) {
          var p = params.join('&')
          appLink += appLink.includes('?') ? `&${p}` : `?${p}`
        }
      }
      console.log(appLink);
      location.href = appLink;
      this.jumpDownloadPage();
    }

  },
  methods: {
    navToRedirectId: function (redirectId) {
      mbff.get(`/cms-service/client-api/short-link/query?id=${redirectId}`).then((response) => {
        const url = response.data.url;
        if (url) {
          console.log(url);
          location.href = url;
        }
        this.jumpDownloadPage();
      }).catch(() => {
        this.jumpDownloadPage();
      });
    },

    navToshortLinkId: function (id) {
      mbff.get(`/content/qr-code/${id}`).then((response) => {
        const url = response.data.url;
        if (url) {
          console.log(url);
          location.href = url;
        }
        this.jumpDownloadPage();
      }).catch(() => {
        this.jumpDownloadPage();
      });
    },

    jumpDownloadPage: function () {
      var downloadLink = "http://res.app.ikea.cn/page/app_download.html"
      var storeId = this.$route.query.utm_campaign;
      var source = this.$route.query.utm_source;
      if (storeId) {
        if (source == 'sms' && smsConfig[storeId]) {
          downloadLink = smsConfig[storeId];
        } else if (source === 'inter_ikea' && interIkeaConfig[storeId]) {
          downloadLink = interIkeaConfig[storeId];
        } else if (offlineConfig[storeId]) {
          downloadLink = offlineConfig[storeId];
        }
      }
      console.log(downloadLink);

      setTimeout(function () {
        window.location.replace(downloadLink);
      }, 2000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bkg {
  position: fixed;
  margin-bottom: 0;
  height: 100%;
  width: 200%;
  margin-top: 180px;
  overflow: hidden;
  background: #ffd800;
  transform: rotate(30deg);
  -webkit-transform: rotate(30deg);
  z-index: -1;
  transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
}

.ikea-icon {
  display: block;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 139px;
  height: 139px;
}

.ikea-title {
  text-align: center;
  font-size: 28px;
  margin-top: 0;
  height: 40px;
}

.sub-title {
  text-align: center;
  font-size: 14px;
  height: 20px;
}

.qr-code-container {
  margin-top: 60px;
  margin-left: auto;
  margin-right: auto;
  width: 140px;
  height: 140px;
  background-color: #ffffff;
  padding: 5px;
}

.qr-code {
  width: 130px;
  height: 130px;
  -webkit-touch-callout: default;
}
</style>



// WEBPACK FOOTER //
// src/pages/app/QRCodeLandingPage.vue